export const prevMonth = (month: number): number => {
  if (month === 0) {
    return 11;
  }
  return month - 1;
};

export const nextMonth = (month: number): number => {
  if (month === 11) {
    return 0;
  }
  return month + 1;
};

export const monthToName: {[month: string]: string} = {
  0: "January",
  1: "February",
  2: "March",
  3: "April",
  4: "May",
  5: "June",
  6: "July",
  7: "August",
  8: "September",
  9: "October",
  10: "November",
  11: "December",
};
